var $c4c2531a5e1343be$exports = {};
const $c4c2531a5e1343be$var$getParentNodes = (node, path)=>{
    path = path || [];
    const { parentNode: parentNode } = node;
    if (!parentNode) return path;
    return $c4c2531a5e1343be$var$getParentNodes(parentNode, path.concat(parentNode));
};
const $c4c2531a5e1343be$var$getEventPath = (event)=>{
    if (event.path) return event.path;
    if (event.composedPath) return event.composedPath();
    return $c4c2531a5e1343be$var$getParentNodes(event.target);
};
window.addEventListener('load', ()=>{
    const docs = [
        ...document.querySelectorAll('.docs-names .doc-name')
    ];
    const activeDoc = docs.find((doc)=>location.href.includes(doc.getAttribute('href').replace('.html', '')));
    const select = document.querySelector('.docs-select');
    const docsContainer = document.querySelector('.docs-names');
    activeDoc.classList.add('active');
    select.querySelector('.selected-doc').innerHTML = activeDoc.innerText;
    document.querySelector('.docs-select').onclick = ()=>docsContainer.classList.toggle('opened');
    window.onclick = (event)=>{
        const path = $c4c2531a5e1343be$var$getEventPath(event);
        const isOutsideClick = !path.includes(document.querySelector('.links-wrapper'));
        if (isOutsideClick) docsContainer.classList.remove('opened');
    };
});


//# sourceMappingURL=docs.e864b9b9.js.map
